import angular, { ILogService } from 'angular'

import { NotificacionService } from '../../../../../_panel/module/uni-base/services/NotifService'
import { IIModel } from '../../../../../model/candidato-api'
import { Editor } from '../editor'
import './editor-form.scss'

class EditorFormComponentCtrl<T extends IIModel> {
  editor!: Editor<T>

  edit = {
    item: {} as T,
  }

  constructor(
    private $log: ILogService,
    private NotifService: NotificacionService
  ) {}

  $onInit(): void {
    this.$log.info('[EditorFormComponentCtrl] onInit')
  }

  guardar() {
    this.editor.guardar(this.edit.item).then(() => {
      this.NotifService.good('Datos guardados')
    })
  }

  nuevo() {
    this.editor.nuevo(this.edit.item).then(() => {
      this.NotifService.good('Datos guardados')
    })
  }
}

angular.module('candidato').component('editorForm', {
  bindings: {
    editor: '<',
  },
  transclude: true,
  controller: EditorFormComponentCtrl,
  template: require('./editor-form.component.html'),
})
